// extracted by mini-css-extract-plugin
export default {"main":"LoginLayout_main__cH+q8"};